import { GridLocaleText } from '@mui/x-data-grid'
import { i18n } from '../i18n'

export const getDataGridLocale = (
  pageSize: number,
): Partial<GridLocaleText> => ({
  noRowsLabel: i18n.t('dataGrid.noRows'),
  MuiTablePagination: {
    labelDisplayedRows: ({ page, count }) =>
      i18n.t('dataGrid.page', {
        page: page + 1,
        total: Math.max(1, Math.ceil(count / pageSize)),
      }),
    labelRowsPerPage: i18n.t('dataGrid.rowsPerPage'),
  },
  toolbarExport: i18n.t('dataGrid.export'),
  toolbarExportCSV: i18n.t('dataGrid.exportCSV'),
})
